module.exports = __webpack_public_path__ + "static/media/Aaron_Walton.7ddd1d0a.jpg";